import { render } from "./LoginView.vue?vue&type=template&id=73c3eefb&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=73c3eefb&scoped=true&lang=css"

import exportComponent from "/var/www/boca/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c3eefb"]])

export default __exports__